import { css } from "styled-components";
import { CardCategory, CardDate, CardInfo, VerticalLine } from "../../components/ArticleFeaturedCard";
import { RelativeFormattedDate } from "../../../../components/RelativeFormattedDate/components/RelativeFormattedDate";
import { CardBody, CardDescription, CardImage, CardTitle } from "../../../../components/Card";
import { Media } from "../../../../components/Media";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
export const riotProductStyle = (chroma, paletteTokens) => css `
  ${chroma.typography.body5};

  ${CardImage} {
    overflow: hidden;
  }

  .icon-action-download,
  .icon-action-external-link,
  .icon-action-image-viewer {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 100%;
    width: clamp(30px, 10%, 100px);
    background-position: bottom;
    ${chroma.typography.display9};
  }

  .icon-action-play-video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    width: clamp(30px, 10%, 100px);
    height: 100%;
    background-position: center;
  }

  &.action ${CardImage} {
    overflow: hidden;

    ${Media} {
      transition: transform 0.3s ease-in-out;
    }
  }

  &:hover {
    &.action ${CardImage} ${Media} {
      transform: scale(1.1);
    }
  }

  ${CardBody} {
    ${CardInfo} {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      float: left;
      ${chroma.typography.body5}
      margin: ${chroma.spacers.constant.s} 0 ${chroma.spacers.constant.xs};

      ${CardCategory} {
        font-weight: bold;
        color: ${paletteTokens.bladetext2};
        ${textUppercaseMixin};
      }

      ${VerticalLine} {
        height: 13px;
        width: 1px;
        background-color: ${paletteTokens.keyline};
        margin: 0 8px;
      }

      ${CardDate} {
        color: ${paletteTokens.bladetext1};
        font-weight: 500;
      }
    }

    ${CardTitle} {
      ${chroma.typography.body2};
      font-weight: bold;
      margin-bottom: ${chroma.spacers.constant.xxs};
    }

    ${RelativeFormattedDate}, ${CardTitle}, ${CardDescription} {
      color: ${paletteTokens.bladetext1};
    }
  }
`;
//# sourceMappingURL=index.js.map